import { Route, Routes } from "react-router-dom";
import Login from "pages/Login";
import Dashboard from "pages/Dashboard";
import Seguidores from "pages/help/Seguidores";
import SobreNosotros from "pages/help/SobreNosotros";
import Promociones from "pages/help/Promociones";
import ListadoInversores from "pages/inversor/ListadoInversores";
import ListadoContadores from "pages/inversor/ListadoContadores";
import GraficaEnergiaPeriodo from "pages/inversor/GraficaEnergiaPeriodo";
import GraficaComparativaProduccion from "pages/inversor/GraficaComparativaProduccion";
import ListadoClientes from "pages/cliente/listadoclientes";
import InformacionCliente from "pages/cliente/informacionCliente";
import NotFound from "routes/notFound";
import GraficaPotenciaInversor from "pages/inversor/GraficasPotenciaInversor";
import ProduccionPeriodo from "pages/produccion/produccionPeriodo";
import InformacionHuerta from "pages/zonaClientes/informacionHuerta";
import AdminProtectedRoutes from "routes/protectedRoutes/AdminProtectedRoutes";
import { useDispatch, useSelector } from "react-redux";
import { isExpired } from "react-jwt";
import { logoutAction } from "store/slices/auth/authSlices";
import ClienteProtectedRoutes from "./protectedRoutes/ClienteProtectedRoutes";
import ProduccionEstimada from "pages/cliente/produccionEstimada";
import FacturacionProtectedRoutes from "./protectedRoutes/FacturacionProtectedRoutes";
import FacturasEmitidas from "pages/facturacion/facturasEmitidas";
import Rendimientoinstalaciones from "pages/produccion/rendimientoInstalaciones";
import LecturasContador from "pages/produccion/lecturasContador";
import GraficasLectura from "pages/produccion/graficasLectura";
import ModificarLecturas from "pages/cliente/modificarLecturas";
import { useEffect } from "react";
import Contacto from "pages/help/contacto";

const AvantSolar = () => {
  const { jwt, status } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isExpired(jwt) && status == "authenticated") {
      dispatch(logoutAction());
    }
  }, [jwt, status]);

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard/*" element={<Dashboard />} />
      {/* Rutas inversores */}
      <Route
        path="/listadoInversores"
        element={
          <AdminProtectedRoutes>
            <ListadoInversores pathname={"Listado Inversores"} />
          </AdminProtectedRoutes>
        }
      />
      <Route
        path="/listadoContadores"
        element={
          <AdminProtectedRoutes>
            <ListadoContadores pathname={"Listado Contadores"} />
          </AdminProtectedRoutes>
        }
      />
      <Route
        path="/graficapotencia"
        element={
          <AdminProtectedRoutes>
            <GraficaPotenciaInversor pathname={"Gráfica Potencia Inversores"} />
          </AdminProtectedRoutes>
        }
      />
      <Route
        path="/graficaenergiaperiodo"
        element={
          <AdminProtectedRoutes>
            <GraficaEnergiaPeriodo pathname={"Gráfica Energía Periodo"} />
          </AdminProtectedRoutes>
        }
      />
      <Route
        path="/graficacomparativaproduccion"
        element={
          <AdminProtectedRoutes>
            <GraficaComparativaProduccion
              pathname={"Gráfica Comparativa Produción"}
            />
          </AdminProtectedRoutes>
        }
      />
      {/* Rutas cliente */}
      <Route
        path="/listadoclientes"
        element={
          <AdminProtectedRoutes>
            <ListadoClientes pathname={"Listado clientes"} />
          </AdminProtectedRoutes>
        }
      />
      <Route
        path="/lecturascliente"
        element={
          <AdminProtectedRoutes>
            <ModificarLecturas pathname={"Lecturas Clientes"} />
          </AdminProtectedRoutes>
        }
      />
      <Route
        path="/informacioncliente/:username"
        element={
          <ClienteProtectedRoutes>
            <InformacionCliente pathname={"Información Cliente"} />
          </ClienteProtectedRoutes>
        }
      />
      {/* Rutas Produccion*/}
      <Route
        path="/produccionperiodo"
        element={
          <AdminProtectedRoutes>
            <ProduccionPeriodo pathname={"Producción Periodo"} />
          </AdminProtectedRoutes>
        }
      />
      <Route
        path="/rendimientoinstalaciones"
        element={
          <AdminProtectedRoutes>
            <Rendimientoinstalaciones pathname={"Rendimiento Instalaciones"} />
          </AdminProtectedRoutes>
        }
      />
      <Route
        path="/lecturascontador"
        element={
          <AdminProtectedRoutes>
            <LecturasContador pathname={"Lecturas Contador"} />
          </AdminProtectedRoutes>
        }
      />
      {/* Rutas zona cliente*/}
      <Route
        path="/informacionHuerta"
        element={
          <ClienteProtectedRoutes>
            <InformacionHuerta pathname={"La huerta"} />
          </ClienteProtectedRoutes>
        }
      />
      <Route
        path="/produccionEstimada"
        element={
          <ClienteProtectedRoutes>
            <ProduccionEstimada pathname={"Producción Estimada"} />
          </ClienteProtectedRoutes>
        }
      />{" "}
      <Route
        path="/graficasLectura"
        element={
          <ClienteProtectedRoutes>
            <GraficasLectura pathname={"Gráficas Lectura"} />
          </ClienteProtectedRoutes>
        }
      />{" "}
      {/* Rutas Facturacion */}
      <Route
        path="/facturasemitidas"
        element={
          <FacturacionProtectedRoutes>
            <FacturasEmitidas pathname={"Facturas Emitidas"} />
          </FacturacionProtectedRoutes>
        }
      />
      {/* Rutas páginas ayuda */}
      <Route
        path="/seguidores"
        element={

          <Seguidores pathname={"Seguidores"} />

        }
      />
      <Route
        path="/sobrenosotros"
        element={
          < SobreNosotros pathname={"Sobre nosotros"} />
        }
      />
      <Route
        path="/promociones"
        element={

          <Promociones pathname={"Promociones"} />

        }
      />
      <Route
        path="/contacto"
        element={

          <Contacto pathname={"Contacto"} />

        }
      />
      {/* Todas las rutas que no estén definidas redirigirán a este componente (Que redirije al componente que sea necesario según el tipo de usuario) */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AvantSolar;
